import React, { Component } from 'react';
import { Form, Modal, message, Button } from 'antd';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';
const { confirm } = Modal;
const api = services.api;
class Nointroduction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };
    }

    showModal = (roomid) => {
        console.log(roomid);
        const { entity } = this.props;
        confirm({
            title: '确认取消推荐吗?',
            content: '请谨慎操作',
            centered: true,
            onOk() {
                api.put({ roomid }, { apiPath: `/live/room/cancelRecommend/${roomid}` })
                    .then(() => {
                        message.success('取消成功');
                        entity.search({
                            ...entity.params,
                            ...entity.filters,
                        });
                    })
                    .catch(errorHandle);
            },
            onCancel() {
                console.log('Cancel');
            },
        });
        this.setState({
            visible: true,
        });
    };

    render() {
        const {
            rows: { roomid, recommend },
        } = this.props;

        return (
            <div>
                {recommend === 'RECOMMEND' && (
                    <Button
                        type="link"
                        style={{ color: 'red' }}
                        onClick={() => this.showModal(roomid)}
                    >
                        取消推荐
                    </Button>
                )}
            </div>
        );
    }
}

export default Form.create()(Nointroduction);
